import { deleteRequest, getRequest, patchRequest, postRequest } from 'services/requests';

const services = {
    createRubric: (body) => postRequest(`/rubrics`, body),
    listRubrics: (filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/rubrics?$filter=${encodeURIComponent(filter)}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
    },
    updateRubric: (id, body) => patchRequest(`/rubrics/${id}`, body),
    deleteRubric: (id) => deleteRequest(`/rubrics/${id}`),
};

export default services;
